import React from "react";
import "../styles/Research.css";
import FinAgent from "../assets/FinAgent.jpg";
import FinAgent_result from "../assets/FinAgent_result.jpg";
import FinAgent_comparison from "../assets/FinAgent_comparison.png";
import FinAgentLogo from "../assets/FinAgentLogo.jpg";
export default function EarnHFT() {
    return (
        <div className="">
            <div className="aa">
                <div className="topa">
                    <div className="form-floating">
                        <img src={FinAgentLogo} alt="FinAgent Logo" style={{ width:'130px' }} />
                        <div className="evt1" style={{marginTop:'-10px',fontSize:'40x',marginLeft:'150px',marginTop:'-120px'}}>
                            
                            FinAgent: A Multimodal Foundation Agent for Financial Trading
                        </div>
                    </div>
                    <div  className="fi1">
                        Tool-Augmented, Diversified, and Generalist
                    </div>

                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        <br />
                        <img src={FinAgent_comparison} alt="FinAgent_comparison" className="img-fluid" />
                        <br />
                        <br />
                        <div  className="fi1">
                            Comparison of FinAgent versus trading strategies and LLM agents.
                        </div>
                       <div  className="fi2">
                       We present FinAgent, a multimodal foundation agent that integrates both textual and visual information
                        for a comprehensive analysis of market dynamics and historical trading patterns. Comparing with the
                        benchmark method, FinAgent highlights it capabilities in terms of using tools,processing diversified
                        information and general ability to adapt to different trading tasks.
                       </div>
                        <br />
                        <br />
                        <div className="fi1" style={{marginTop:'-10px'}}>
                            Key Features
                        </div>
                        <br />
                        <img src={FinAgent} alt="FinAgent" className="img-fluid" />
                        <div className="fi1" >
                            The Architecture of FinAgent
                        </div>

                        <div className="fi2">
                        (1) The market intelligence module processes multimodal data, such as numerical,
                        textual, and visual, to provide precise analysis of financial market trends, offering insights for
                        future trading tasks.
                        <br />
                        <br />
                        (2) The uniquely designed dual-level reflection module is capable of not only rapidly adapting
                        to market dynamics but also enhancing the agent's ability to learn from historical data and improve its
                        decision-making process.
                        <br />
                        <br />
                        (3) The diversified memory retrieval system for the market intelligence and reflection
                        modules, separating trading and retrieval tasks to enhance focus on their specific functions and
                        minimize noise in the results.
                        <br />
                        <br />
                        (4) The decision-making module incorporates expert knowledge, comprising both supplementary expert
                        guidance and auxiliary expert strategies, to guide the agent's decisions. This emphasis on providing
                        reasoned explanations for actions fosters trust in its financial decisions.
                        </div>

                    </h5>
                </div>
            </div>


            <div className="topa2">
            <div className="History">
                Results
            </div>
            <br />
            <img src={FinAgent_result} alt="FinAgent_result" className="img-fluid" />
            <br />
            <br />
            <div className="History" style={{marginTop:'50px'}}>
                Performance comparison over time between FinAgent and other benchmarks across all assets.
            </div>
            <br />
            <div className="fia3">
                We compared FinAgent with 9 baseline methods including . The result demonstrate our method significantly
                outperforms existing baselines, especially remarkable improvements in profitability, and setting a new
                benchmark in the field.
            </div>

            <br />
            <div className="fia3">
                For more information concerning FinAgent, please refer to the following materials:
                <br />
                Paper: <strong>
                    <a
                        href="https://arxiv.org/abs/2402.18485"
                        style={{ textDecoration: "underline" }}
                        target="_blank"
                    >
                        <strong> FinAgent paper </strong> </a>
                </strong>&nbsp;&nbsp;&nbsp;
                <br />
                Code: <strong> To Be Released Soon</strong>&nbsp;&nbsp;&nbsp;
                {/*    <a*/}
                {/*    href="https://github.com/qinmoelei/EarnHFT"*/}
                {/*    style={{ textDecoration: "underline" }}*/}
                {/*    target="_blank"*/}
                {/*>*/}
                {/*    EarnHFT code </a></strong>*/}
            </div>

            </div>

        </div>
    );
}
